import request from './request'

export interface UpdateUserStatusParams {
  id: number
  status: number
}

export interface ApiResponse<T = unknown> {
  code: number
  data: T
  msg: string
}

/** Possible fields when deactivate is blocked by unfinished orders/subscriptions. */
export interface UpdateUserStatusData {
  can_deactivate?: boolean
  has_orders?: boolean
  has_subscriptions?: boolean
  has_order?: boolean
  has_subscription?: boolean
  has_unfinished_orders?: boolean
  has_unfinished_subscriptions?: boolean
  reason?: string
}

export async function updateUserStatus(params: UpdateUserStatusParams) {
  return request.post<ApiResponse<UpdateUserStatusData | unknown>>(
    '/api/admin/user/update-status',
    params,
  )
}

function readBool(value: unknown): boolean | undefined {
  return typeof value === 'boolean' ? value : undefined
}

/**
 * Detect when deactivate failed because the user still has unfinished orders or subscriptions.
 * Supports common data flags and order/subscription-related msg text from the backend.
 */
export function isDeactivateBlockedByOrdersOrSubscriptions(
  response: ApiResponse<unknown>,
): boolean {
  if (response.code === 200) return false

  const data = response.data
  if (data && typeof data === 'object') {
    const d = data as UpdateUserStatusData & Record<string, unknown>
    if (readBool(d.can_deactivate) === false) return true
    if (
      readBool(d.has_orders) === true ||
      readBool(d.has_subscriptions) === true ||
      readBool(d.has_order) === true ||
      readBool(d.has_subscription) === true ||
      readBool(d.has_unfinished_orders) === true ||
      readBool(d.has_unfinished_subscriptions) === true
    ) {
      return true
    }
    const reason = typeof d.reason === 'string' ? d.reason.toLowerCase() : ''
    if (
      reason.includes('order') ||
      reason.includes('subscription') ||
      reason.includes('订单') ||
      reason.includes('订阅')
    ) {
      return true
    }
  }

  const msg = (response.msg || '').toLowerCase()
  const mentionsOrdersOrSubs =
    msg.includes('order') ||
    msg.includes('subscription') ||
    msg.includes('订单') ||
    msg.includes('订阅')
  if (!mentionsOrdersOrSubs) return false

  return (
    msg.includes('cannot') ||
    msg.includes('can not') ||
    msg.includes("can't") ||
    msg.includes('unable') ||
    msg.includes('deactivat') ||
    msg.includes('不可') ||
    msg.includes('不能') ||
    msg.includes('无法') ||
    msg.includes('exist') ||
    msg.includes('unfinished') ||
    msg.includes('active') ||
    msg.includes('未结束')
  )
}
